// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multicell-selector-container {
  max-height: clamp(50vh, 15vh + 5vw, 75vh);
}

.cell-selector-width-three-column {
  width: 576px;
}

.cell-selector-width-two-column {
  width: 432px;
}
`, "",{"version":3,"sources":["webpack://./src/context-selector/components/MultiCellSelector.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".multicell-selector-container {\n  max-height: clamp(50vh, 15vh + 5vw, 75vh);\n}\n\n.cell-selector-width-three-column {\n  width: 576px;\n}\n\n.cell-selector-width-two-column {\n  width: 432px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
